module.exports = __webpack_public_path__ + "static/media/icon_pdf.ce54aa0b.png";